import { createAction } from "redux-actions";
import types from "../types/config";

export const receiveConfig = createAction(types.CONFIGURATION_RECEIVED);



// WEBPACK FOOTER //
// ./src/redux/actions/config.js